/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import { Header, ThemContainer, DateCard } from './style';
import { Waiting } from '..';
import { fetchMonthlyRewardsPoint } from '../../redux/actions';
import { ImageUrl } from '../../utils/constants';
import LazyImage from '../common/LazyImage/LazyImage';
const Days = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat"
];

class NameHeader extends Component {
  constructor() {
    super();
    this.state = {
      month: '',
      hideContent: false
    };
  }
  
  mayMonth = () => (
    <svg
      width={133}
      height={149}
      viewBox="0 0 133 149"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2269_133276)">
        <path
          d="M59.3708 50.9421C59.2042 54.8958 58.2988 58.8205 56.7271 62.5348H73.4734C70.6702 57.4494 69.0333 51.6675 70.5544 46.2121C72.6114 38.856 79.7822 33.6618 85.642 28.0976C91.5017 22.5406 96.5792 14.6912 93.2763 7.69788C90.437 1.67663 81.7886 -1.21067 74.6178 0.486889C67.447 2.18445 61.9711 7.61808 59.3853 13.7264C56.7995 19.8347 56.7415 26.5451 57.5166 33.0234C58.2336 38.9939 59.6243 44.9426 59.3636 50.9493L59.3708 50.9421Z"
          fill="#CE98B3"
        />
        <path
          d="M53.0466 71.377H57.5156C61.2893 65.8418 63.2885 59.0951 63.0422 52.3919C62.7814 45.2679 59.9711 38.2456 55.1761 32.9715C52.0904 29.5764 47.9473 26.8197 43.3696 26.6601C38.7919 26.5005 33.9462 29.649 33.3522 34.2048C32.9104 37.5564 34.7574 40.8354 37.1549 43.2149C39.5524 45.5944 42.5077 47.3137 45.1225 49.4538C48.4326 52.1597 51.2213 55.5911 52.7423 59.5811C54.1692 63.3317 54.4083 67.6046 53.0538 71.3697L53.0466 71.377Z"
          fill="#A65C7C"
        />
        <path
          d="M47.0202 1.99439C43.5507 1.67519 40.5231 4.92522 39.7336 8.21877C36.7494 6.55748 32.2151 6.63728 30.1291 9.48831C27.9851 12.4119 29.6655 16.4817 32.0992 18.5637C33.9245 20.1234 36.2278 21.0085 38.5457 21.6179C40.8635 22.2272 44.7676 22.0169 47.0709 22.6843C48.0995 20.5152 49.4105 18.4912 50.497 16.3511C51.5835 14.211 52.4527 11.8968 52.4961 9.49556C52.5541 6.28907 50.6274 2.33535 47.0202 2.00165V1.99439Z"
          fill="#CE98B3"
        />
        <path
          d="M31.7448 82.9551C20.851 84.036 10.0079 88.4467 4.26403 97.5802C-2.92124 108.992 0.649666 125.452 11.1016 133.962C21.5608 142.464 37.3003 143.015 49.114 136.537C54.3002 133.686 58.8706 129.638 63.6005 125.996"
          stroke="#092F41"
          strokeWidth={0.677169}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.358 61.5546C107.5 57.1729 116.844 55.4754 123.674 61.4023C131.997 68.6278 133.996 83.7752 131.874 93.8518C130.765 99.0895 128.339 104.023 125.022 108.216C121.552 112.59 116.982 116.246 111.636 117.828C108.637 118.713 105.566 118.916 102.459 118.8"
          stroke="#092F41"
          strokeWidth={0.677169}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.674 58.4572C76.6238 53.8869 77.4495 49.0118 79.4124 44.7534C81.3753 40.495 84.432 36.817 87.858 33.625C90.7191 30.9553 93.9713 28.5468 97.745 27.5167C107.342 24.8905 120.011 41.634 107.429 44.5648C104.952 45.1452 102.373 44.7824 99.8455 44.5358C96.8179 44.2383 93.725 44.115 90.7698 44.8622C87.8218 45.6095 85.0042 47.3215 83.5121 49.9839C82.02 52.6391 81.8244 56.5783 83.9394 58.7692L77.6668 58.4645L77.674 58.4572Z"
          fill="#A65C7C"
        />
        <path
          d="M93.2749 110.262C95.4551 113.149 98.9319 115.013 102.539 115.238"
          stroke="#092F41"
          strokeWidth={0.695471}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.2214 136.843V148.798L35.3301 148.602C35.3301 148.602 45.9124 123.864 46.7092 111.176L50.6133 109.631"
          stroke="#092F41"
          strokeWidth={0.915093}
          strokeMiterlimit={10}
        />
        <path
          d="M38.1051 141.695C36.5044 145.838 35.3237 148.594 35.3237 148.594L85.215 148.79V141.695H38.1051Z"
          fill="#BE7D9C"
        />
        <path
          d="M99.9664 57.2882V57.2882C99.8796 56.4317 99.1586 55.7793 98.2977 55.7793H31.8017C31.0823 55.7793 30.4244 56.1988 30.1573 56.8669C28.7908 60.2848 28.102 64.0087 28.1282 67.6912C28.1789 75.2649 30.9747 82.6355 35.0599 89.0122C38.8988 94.9972 43.8387 100.184 48.0253 105.923C50.2345 108.948 52.2481 112.14 54.3341 115.274C60.7371 124.886 73.1375 136.109 85.2192 136.849C93.1143 137.335 98.9523 130 101.292 123.217C104.406 114.149 102.943 104.363 102.465 95.0117C101.821 82.4324 101.176 69.8386 99.9664 57.3027V57.2882Z"
          stroke="#092F41"
          strokeWidth={0.915093}
          strokeMiterlimit={10}
        />
        <path
          d="M99.5898 53.5957H31.7353C29.3161 57.8251 28.092 62.7944 28.1282 67.6912C28.1789 75.265 30.9748 82.6355 35.06 89.0123C38.8989 94.9972 43.8388 100.184 48.0253 105.923C50.2345 108.948 52.2481 112.14 54.3342 115.274C54.5587 115.615 54.7978 115.956 55.0368 116.297C55.7901 114.468 56.4854 112.618 57.1083 110.74C58.8974 105.306 60.0274 99.6692 60.3098 93.9526C60.6068 87.9531 60.0056 81.9464 58.8395 76.0629C58.7888 75.8163 58.9554 75.5189 59.2378 75.5334C60.3895 75.6132 61.5557 75.4608 62.5914 74.9312C66.1479 73.1104 67.1112 68.3151 66.7925 64.6806C66.7563 64.3034 67.1619 64.1946 67.4227 64.3542C67.4879 64.3034 67.5748 64.2671 67.6762 64.2671H100.575C100.387 61.9457 100.191 59.6242 99.9664 57.3028C99.8506 56.0695 99.7202 54.8435 99.5898 53.6102V53.5957Z"
          fill="#092F41"
        />
        <path
          d="M61.042 108.18C62.5781 99.8305 57.0653 91.8149 48.729 90.2764C40.3926 88.738 32.3895 94.2594 30.8535 102.609C29.3175 110.958 34.8302 118.974 43.1665 120.512C51.5029 122.051 59.506 116.529 61.042 108.18Z"
          fill="#EEDCE6"
        />
        <path
          d="M102.994 103.333L105.913 102.113C107.576 101.419 109.136 103.292 108.153 104.801L103.168 112.452"
          stroke="#092F41"
          strokeWidth={0.915093}
          strokeMiterlimit={10}
        />
        <path
          d="M93.2749 110.262C95.4551 113.149 98.9319 115.013 102.539 115.238"
          stroke="#092F41"
          strokeWidth={0.695471}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.2979 105.713C39.5441 103.028 41.4346 100.613 43.9118 99.5463C46.389 98.4871 49.337 98.741 51.6982 100.04C49.0255 99.909 46.5411 102.23 46.2731 104.893C45.9978 107.555 47.7941 110.232 50.2858 111.197"
          stroke="#092F41"
          strokeWidth={0.677169}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.39 84.8262C94.7386 88.3446 91.0083 90.7821 87.126 90.8837"
          stroke="#092F41"
          strokeWidth={0.695471}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M97.1066 97.3404C97.2515 98.6607 96.3823 99.9883 95.1727 100.532C93.9631 101.076 92.4927 100.895 91.3483 100.213C90.2111 99.5313 89.3854 98.3923 88.9146 97.1445"
          stroke="#092F41"
          strokeWidth={0.695471}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.725 108.157C88.653 110.638 83.9739 110.994 79.2658 108.955C74.5577 106.917 71.617 103.261 72.6817 100.78C73.7465 98.2985 78.4328 97.9431 83.1409 99.9816C87.849 102.02 90.7898 105.676 89.725 108.157Z"
          fill="#CE98B3"
        />
        <path
          d="M120.473 61.0254C121.93 61.0254 123.11 59.8432 123.11 58.3848C123.11 56.9264 121.93 55.7441 120.473 55.7441C119.017 55.7441 117.837 56.9264 117.837 58.3848C117.837 59.8432 119.017 61.0254 120.473 61.0254Z"
          fill="#092F41"
        />
        <path
          d="M11.2686 92.1392C11.2686 93.2855 10.3415 94.214 9.19705 94.214C8.05262 94.214 7.12549 93.2855 7.12549 92.1392C7.12549 90.993 8.05262 90.0645 9.19705 90.0645C10.3415 90.0645 11.2686 90.993 11.2686 92.1392Z"
          fill="#092F41"
        />
        <path
          d="M15.7879 140.231C17.244 140.231 18.4244 139.048 18.4244 137.59C18.4244 136.131 17.244 134.949 15.7879 134.949C14.3318 134.949 13.1514 136.131 13.1514 137.59C13.1514 139.048 14.3318 140.231 15.7879 140.231Z"
          fill="#092F41"
        />
        <path
          d="M124.238 113.264C124.238 114.2 123.478 114.962 122.544 114.962C121.609 114.962 120.849 114.2 120.849 113.264C120.849 112.328 121.609 111.566 122.544 111.566C123.478 111.566 124.238 112.328 124.238 113.264Z"
          fill="#092F41"
        />
        <path
          d="M14.6569 74.9819C15.905 74.9819 16.9167 73.9685 16.9167 72.7185C16.9167 71.4684 15.905 70.4551 14.6569 70.4551C13.4088 70.4551 12.397 71.4684 12.397 72.7185C12.397 73.9685 13.4088 74.9819 14.6569 74.9819Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3072 64.7966C20.9312 64.7966 21.4371 64.2899 21.4371 63.6649C21.4371 63.0399 20.9312 62.5332 20.3072 62.5332C19.6831 62.5332 19.1772 63.0399 19.1772 63.6649C19.1772 64.2899 19.6831 64.7966 20.3072 64.7966Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.3216 119.301C23.3216 120.026 22.7349 120.621 22.0033 120.621C21.2718 120.621 20.6851 120.033 20.6851 119.301C20.6851 118.568 21.2718 117.98 22.0033 117.98C22.7349 117.98 23.3216 118.568 23.3216 119.301Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1497 114.207C13.9817 114.207 14.6562 113.532 14.6562 112.698C14.6562 111.865 13.9817 111.189 13.1497 111.189C12.3176 111.189 11.6431 111.865 11.6431 112.698C11.6431 113.532 12.3176 114.207 13.1497 114.207Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.312 73.4743C110.936 73.4743 111.442 72.9677 111.442 72.3426C111.442 71.7176 110.936 71.2109 110.312 71.2109C109.688 71.2109 109.182 71.7176 109.182 72.3426C109.182 72.9677 109.688 73.4743 110.312 73.4743Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.714 84.9785C116.714 85.704 116.127 86.2988 115.396 86.2988C114.664 86.2988 114.078 85.7112 114.078 84.9785C114.078 84.2458 114.664 83.6582 115.396 83.6582C116.127 83.6582 116.714 84.2458 116.714 84.9785Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.982 41.7933C122.814 41.7933 123.488 41.1177 123.488 40.2843C123.488 39.451 122.814 38.7754 121.982 38.7754C121.15 38.7754 120.475 39.451 120.475 40.2843C120.475 41.1177 121.15 41.7933 121.982 41.7933Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M105.79 16.3301C105.79 17.0628 105.204 17.6504 104.472 17.6504C103.741 17.6504 103.154 17.0628 103.154 16.3301C103.154 15.5974 103.741 15.0098 104.472 15.0098C105.204 15.0098 105.79 15.5974 105.79 16.3301Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.064 131.553C111.896 131.553 112.571 130.877 112.571 130.044C112.571 129.211 111.896 128.535 111.064 128.535C110.232 128.535 109.558 129.211 109.558 130.044C109.558 130.877 110.232 131.553 111.064 131.553Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.648 141.738C102.272 141.738 102.777 141.231 102.777 140.606C102.777 139.981 102.272 139.475 101.648 139.475C101.023 139.475 100.518 139.981 100.518 140.606C100.518 141.231 101.023 141.738 101.648 141.738Z"
          stroke="#092F41"
          strokeWidth={0.49415}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2269_133276">
          <rect
            width={132.688}
            height={149.16}
            fill="white"
            transform="translate(0.236816)"
          />
        </clipPath>
      </defs>
    </svg>
  )

  themeData = [
    {
      "themeBackground": "/admin-page/Jan.png",
      "themeText": "Self-Improvement Month",
      "color": "#B54D93"
    },
    {
      "themeBackground": "/admin-page/February.png",
      "themeText": "Heart Health Month",
      "color": "#A62F3D"
    },
    {
      "themeBackground": "/admin-page/March.png",
      "themeText": "Complete Wellbeing",
      "color": "#8D7D41"
    },
    {
      "themeBackground": "/admin-page/April.png",
      "themeText": "Active Living Month",
      "color": "#D7442B"
    },
    {
      "themeBackground": "/admin-page/May.png",
      "themeText": "Mental Health Awareness Month",
      "color": "#8D4964"
    },
    {
      "themeBackground": "/admin-page/June.png",
      "themeText": "Workplace Wellbeing and Occupational Health",
      "color": "#2F6C42"
    },
    {
      "themeBackground": "/admin-page/July.png",
      "themeText": " Focus on Health Month",
      "color": "#A62F3D"
    },
    {
      "themeBackground": "/admin-page/August.png",
      "themeText": "Healthy Habits Month",
      "color": "#6A73C1"
    },
    {
      "themeBackground": "/admin-page/September.png",
      "themeText": "Longevity Month",
      "color": "#C06236"
    },
    {
      "themeBackground": "/admin-page/October.png",
      "themeText": "Work-Life Balance Month",
      "color": "#6A73C1"
    },
    {
      "themeBackground": "/admin-page/November.png",
      "themeText": "Mindfulness Month",
      "color": "#C06236"
    },
    {
      "themeBackground": "/admin-page/December.png",
      "themeText": "Social Connectedness Month",
      "color": "#B54D93"
    }
  ]
  

  render() {
    const { monthlyRewardPoint, totalPoints, themesHeader } = this.props;
    const d = new Date;
    const date = new Date();
    const day = date.getDay();
    if (isNull(monthlyRewardPoint) || isNull(totalPoints)) {
      return <Waiting />
    }
    const themeStyle = themesHeader?themesHeader:[];
    const currentMonth = new Date().getMonth();
    const currentMonthTheme=this.themeData[currentMonth]
    return (
      <Header bgColor={currentMonthTheme?.color} backgroundImage={currentMonthTheme?.themeBackground}>
        <DateCard bgColor={currentMonthTheme?.color} >
          <p className="first">{Days[day]}</p>
          <p className="last">{new Date().getDate()}</p>
        </DateCard>
        <ThemContainer bgColor={currentMonthTheme?.color} >
          <div>
            <p className="first">{themeStyle && themeStyle.month || ''} {themeStyle && themeStyle.year || ''}</p>
            <p className="last">{currentMonthTheme.themeText}</p>
          </div>
          <div>
            {/* <LazyImage src={`${ImageUrl}/${themeStyle && themeStyle.image_url}`} /> */}
            {/* {this.mayMonth()} */}
          </div>
        </ThemContainer>
      </Header>
    )
  }
}

NameHeader.propTypes = {
  history: PropTypes.object.isRequired,
  userDetails: PropTypes.object.isRequired,
  fetchMonthlyRewardsPoint: PropTypes.func,
  monthlyRewardPoint: PropTypes.number,
  totalPoints: PropTypes.object,
  companyInfo: PropTypes.object,
  isAdmin: PropTypes.bool,
  role: PropTypes.bool,
  userCompany: PropTypes.object,
  themesHeader: PropTypes.array
};

const mapStateToProps = (state) => ({
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  totalPoints: state.wellnessDashboard.reward,
  companyInfo: state.companyDashboard.companyInfo,
  themesHeader: state.profileData.themesHeader
});

const mapDispatchToProps = (dispatch) => ({
  fetchMonthlyRewardsPoint: (startDate) => dispatch(fetchMonthlyRewardsPoint(startDate))
})

export default connect(mapStateToProps, mapDispatchToProps)(NameHeader);
